import React, { Component } from 'react';

const createTable = (erroresProcesos, checkFunction, checkFunctionAll, data,IdProcesoEstado, IdProcesoTraza) => {
    /*HEADER*/
    let permiteReprocesar = erroresProcesos.some(err=>err.Descripcion.toUpperCase() != "NOTA");
    permiteReprocesar = data.colorEstado.toUpperCase() == "ROJO" || data.colorEstado.toUpperCase() == "VERDE" ? false : permiteReprocesar;
    permiteReprocesar = IdProcesoEstado == 10 && erroresProcesos[0].ProcesoTrazaId == IdProcesoTraza ? true : false;

    let camposComunes = ["NombreLabelDetalle","Descripcion","RegistroMensajeError","ID","ProcesoTrazaId","EstadoId","RowId","rSpan","desestimar","reprocesar","noCheck"]
    
    let campos = Object.getOwnPropertyNames(erroresProcesos[0]);

    campos = campos.filter(campo => !camposComunes.some(c2 => c2 == campo))//los campos que siempre van a estar se hardcodean luego, el resto varía

    let columnasVariables = campos.map(c => <th>{c}</th>)
    let claseDescripcion, tablaErroresProcesos;

    if(columnasVariables.length == 0){
        claseDescripcion =  "tablaErroresProcesosMinWidth";
        tablaErroresProcesos = "tablaErroresProcesos";
    }
    else{
        claseDescripcion =  "";
        tablaErroresProcesos = "tablaErroresProcesos tablaErroresProcesosOverFlow";
    }

    let headerFinal =
        <thead>
            {permiteReprocesar && <th>
                DESESTIM.
                <div className="default-checkbox checkProcesosSmall">
                    <input
                        id={"ProcesosDesestimarTodos"}
                        type="checkbox"
                        name={"ProcesosDesestimarTodos"}
                        checked={data.desestimaTodos}
                        disabled={false}
                        onChange={(e) => { checkFunctionAll("desestimar"); }}
                    />
                    <label className={"label-primary TableroProcesos-checkboxLabel" + (data.desestimaTodos ? " TableroProcesos-checkboxLabelSmall--checked" : "")} htmlFor={"ProcesosDesestimarTodos"}></label>
                </div>
            </th>}
            {permiteReprocesar && <th>
                REPROCES.
                <div className="default-checkbox checkProcesosSmall">
                    <input
                        id={"ProcesosReprocesarTodos"}
                        type="checkbox"
                        name={"ProcesosReprocesarTodos"}
                        checked={data.reprocesaTodos}
                        disabled={false}
                        onChange={(e) => { checkFunctionAll("reprocesar"); }}
                    />
                    <label className={"label-primary TableroProcesos-checkboxLabel" + (data.reprocesaTodos ? " TableroProcesos-checkboxLabelSmall--checked" : "")} htmlFor={"ProcesosReprocesarTodos"}></label>
                </div>
            </th>}
            <th>TIPO ERROR</th>
            <th className={claseDescripcion + "adjustTextMinWidth"}>MENS. ERROR</th>
            {columnasVariables}
        </thead>


    /*BODY*/
    let rowsByRowId = {};
    let arregloFinalRows = [];

    // se guardan los registros en el objeto rowsByRowId, una key por cada RowId
    let cuerpoTabla = erroresProcesos.map(er => {
        if (!rowsByRowId[er.RowId]) {
            rowsByRowId[er.RowId] = [er]
        } else {
            rowsByRowId[er.RowId].push(er)
        }
    })

    let RowIds = Object.getOwnPropertyNames(rowsByRowId);

    RowIds.map((rId) => {
        rowsByRowId[rId].map((row, index, arr) => {
            if (index == 0) {
                row.rSpan = arr.length;//se asigna la cantidad de líneas para hacer el rowspan en la tabla
            } else {
                row.noCheck = true;
            }
            arregloFinalRows.push(row)
        })
    })
    let contadorRowFondo = { row: 0, fondoCeleste: true };

    let cuerpoFinal = arregloFinalRows.map((r,index)=>{
        let muestraCheck = r.Descripcion && r.Descripcion.toUpperCase() != "NOTA";

        if(contadorRowFondo.row != r.RowId){
            contadorRowFondo.row=r.RowId;
            contadorRowFondo.fondoCeleste=!contadorRowFondo.fondoCeleste;
        } 
        
        return (<tr className={contadorRowFondo.fondoCeleste ? "backgroundGrisFila":""}>
        {permiteReprocesar && !r.noCheck && <td rowSpan = {r.rSpan ? r.rSpan : null}>
                {muestraCheck && <div className="default-checkbox checkProcesosLarge">
                    <input
                        id={"ProcesosDesestimar" + r.ID}
                        type="checkbox"
                        name={"ProcesosDesestimar" + r.ID}
                        checked={r.desestimar}
                        disabled={false}
                        onChange={(e) => { checkFunction(r.RowId, "desestimar") }}
                    />
                    <label className={"label-primary TableroProcesos-checkboxLabel" + (r.desestimar ? " Tarjetas-checkboxLabelRegistro--checked" : "")} htmlFor={"ProcesosDesestimar"+r.ID}></label>
                </div>}
            </td>}
        {permiteReprocesar && !r.noCheck && <td rowSpan = {r.rSpan ? r.rSpan : null}>
        {muestraCheck && <div className="default-checkbox checkProcesosLarge">
                    <input
                        id={"ProcesosReprocesar" + r.ID}
                        type="checkbox"
                        name={"ProcesosReprocesar" + r.ID}
                        checked={r.reprocesar}
                        disabled={false}
                        onChange={(e) => {/*selectCheckBox(e);*/ checkFunction(r.RowId, "reprocesar") }}
                    />
                    <label className={"label-primary TableroProcesos-checkboxLabel" + (r.reprocesar ? " Tarjetas-checkboxLabelRegistro--checked" : "")} htmlFor={"ProcesosReprocesar"+r.ID}></label>
                </div>}
            </td>}
            <td>{r.Descripcion}</td>
            <td className="adjustTextWordBreak">{r.RegistroMensajeError}</td>
            {campos.map(c => <td>{r[c]}</td>)/*el resto de los campos varia por lo que se tratan de la misma manera que el header, se toman del mismo arreglo para que tengan el mismo orden*/}
        </tr>)
    })

    return (
        <div className={tablaErroresProcesos}>
            <table id="ErroresProcesos">
                {headerFinal}
                <tbody>
                    {cuerpoFinal}
                </tbody>
            </table>
        </div>
    );
}
 
class TablaErrores extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillUnmount() {
            if(this.props.data.desestimaTodos || this.props.data.reprocesaTodos) this.props.checkAllError("clean");
    }

    render() {
        const { data,IdProcesoEstado, IdProcesoTraza } = this.props;

        let table = (data.erroresProceso && data.erroresProceso.length > 0) ? createTable(data.erroresProceso, this.props.checkError, this.props.checkAllError, data,IdProcesoEstado, IdProcesoTraza) : null;
        return (
            <div>
                {table}
            </div>

        );
    }
}

export default TablaErrores;